import sk from './sk/translation';
import en from './en/translation';

export default { en, sk };



// WEBPACK FOOTER //
// ./src/app/i18n/locales/index.js